define("calendar/helpers/format-bttp", ["exports", "@ember/component/helper", "moment"], function (_exports, _helper, _moment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"moment"eaimeta@70e063a35619d71f
  const formatBttpHelperFn = _ref => {
    let [startMins] = _ref;
    return (0, _moment.default)().startOf('day').add(startMins, 'minutes').format('h:mmA');
  };
  const formatBttpHelper = (0, _helper.helper)(formatBttpHelperFn);
  var _default = _exports.default = formatBttpHelper;
});